import { gql } from '@apollo/client'

export const CURRENCY_CONVERSIONS_BY_EMPLOYEE = gql`
  query GetCurrencyConversionsByEmployee($employeeId: HashedId!) {
    getCurrencyConversionsByEmployee(employeeId: $employeeId) {
      id
      currencyConversionData {
        id
        startingCurrency
        targetCurrency
        conversionRate
      }
      contractCurrency
    }
  }
`
